import { Container, Box, Grid } from "theme-ui";

import { Trove } from "../components/Trove/Trove";
import { Stability } from "../components/Stability/Stability";
import { Staking } from "../components/Staking/Staking";
import { SystemStats } from "../components/SystemStats";

export const Dashboard: React.FC = () => (
  <Container variant="main">
    {/* Top row: Trove, Stability Pool, Staking */}
    <Grid
      columns={[1, 1, 3]}
      gap={3}
      sx={{
        mb: 4,
        alignItems: "stretch",
        "& > div": {
          display: "flex",
          flexDirection: "column"
        },
        "& > div > div": {
          display: "flex",
          flexDirection: "column",
          height: "100%"
        }
      }}
    >
      <Box>
        <Trove />
      </Box>
      <Box>
        <Stability />
      </Box>
      <Box>
        <Staking />
      </Box>
    </Grid>

    {/* Bottom row: System Stats (full width) */}
    <SystemStats />
  </Container>
);
